import { getCookie } from '../../../utils';

export const getTrackingConsent = () => {
  const optanonCookie = getCookie('OptanonConsent');
  if (!optanonCookie) {
    return 'not-granted';
  }

  const groups = new URLSearchParams(optanonCookie).getAll('groups');
  if (groups.length !== 1) {
    return 'not-granted';
  }
  const trackingGroups = groups[0].split(',').filter((group) => group.split(':')[0] === 'C0002');
  return trackingGroups.length === 1 && trackingGroups[0] === 'C0002:1' ? 'granted' : 'not-granted';
};
